import { render, staticRenderFns } from "./FiltrosModeloCampanha.vue?vue&type=template&id=623ff188&scoped=true&"
import script from "./FiltrosModeloCampanha.vue?vue&type=script&lang=js&"
export * from "./FiltrosModeloCampanha.vue?vue&type=script&lang=js&"
import style0 from "./FiltrosModeloCampanha.vue?vue&type=style&index=0&id=623ff188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623ff188",
  null
  
)

export default component.exports